import { render, staticRenderFns } from "./ModalAlterarDados.vue?vue&type=template&id=6175aef8&scoped=true"
import script from "./ModalAlterarDados.vue?vue&type=script&lang=js"
export * from "./ModalAlterarDados.vue?vue&type=script&lang=js"
import style0 from "./ModalAlterarDados.vue?vue&type=style&index=0&id=6175aef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6175aef8",
  null
  
)

export default component.exports